import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import { getFilteredProgramDirector } from "../../../reducer/programDirector/action";
import dayjs from "dayjs";

function ListProgramDirector(props) {
  useEffect(() => {
    props.getFilteredProgramDirector(1, -1, {
      // accepted: true,
      dashboardYear: props.chosenYear,
      departmentId: props.chosenDepartmentId,
      acceptedOne: true,
    });
  }, [props.chosenYear]);

  const getProgramDirectorType = (type) => {
    switch (type) {
      case "national_level_director":
        return "Chương trình Cấp Quốc gia";
      default:
        return "";
    }
  };

  const getProgramDirectorTitle = (info, index) => {
    return (
      <div key={`programDirector-${index}`} style={{ marginTop: 16 }}>
        <div>
          <b style={{ color: "gray" }}>
            {index + 1}. Tên {getProgramDirectorType(info.programDirector.type)}:{" "}
          </b>
          <i style={{ color: "red" }}> {info.programDirector.title}</i>
        </div>
        <div style={{ marginLeft: 20 }}>
          <b>- Mã quản lý: </b>
          {info.programDirector.code || ""}
          <br />
          <b>- Thời gian bắt đầu: </b>
          {dayjs(info.programDirector.startTime).format("DD/MM/YYYY")}
          <br />
          <b>- Thời gian kết thúc: </b>
          {dayjs(info.programDirector.endTime).format("DD/MM/YYYY")}
          <br />
        </div>
      </div>
    );
  };

  return props.isFetching ? (
    <div style={{ textAlign: "center" }}>
      <CircularProgress />
    </div>
  ) : (
    <Box paddingRight={1} height="calc(100vh - 214px)" minWidth="calc(100% + 8px)" style={{ overflowY: "auto" }}>
      {props.listProgramDirectorAccepted.map((item, index) => getProgramDirectorTitle(item, index))}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  listProgramDirectorAccepted: select(state, "programDirectorReducer", "listFiltered"),
  isFetching: select(state, "programDirectorReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  getFilteredProgramDirector: (page, pageSize, payload) =>
    dispatch(getFilteredProgramDirector(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ListProgramDirector));

